const mouseDragged = (event, provider) => {
    provider.tools.currentTool.dragMouse(event);
}

const onCanvas = (provider) => {
    let p = provider.p;
    return !provider.sideBar.hovered()
        && p.mouseX > 0
        && p.mouseX < p.width
        && p.mouseY > 0
        && p.mouseY < p.height;
}

const releaseMouseOnCanvas = (provider) => {
    return () => {
        if (onCanvas(provider)) {
            provider.tools.currentTool.releaseMouseOnCanvas();
        }
    }
}

const clickMouseOnCanvas = (provider) => {
    return () => {
        if (onCanvas(provider)) {
            provider.tools.currentTool.clickMouseOnCanvas();
        }
    }
}

const pressMouseOnCanvas = (provider) => {
    return () => {
        if (onCanvas(provider)) {
            provider.tools.currentTool.pressMouseOnCanvas();
        }
    }
}

const doubleClickedOnCanvas = (provider) => {
    return (event) => {
        if (onCanvas(provider)) {
            provider.tools.currentTool.doubleClickedOnCanvas();
            // if (document.selection && document.selection.empty) {
            //     document.selection.empty();
            // } else if (window.getSelection) {
            //     var sel = window.getSelection();
            //     sel.removeAllRanges();
            // }
        }
    }
}

const mouseMoved = (provider) => {
    // It can happen that the mouseMoved event is triggered before the provider is initialized.
    if (!provider) {
        return;
    }
    if (onCanvas(provider)) {
        provider.tools.currentTool?.moveMouse(provider);
    }
}

const mouseWheel = (event, provider) => {
    if (provider.tools.currentTool.scrollEnabled && !provider.sideBar.hovered()) {
        event.preventDefault();
        if (provider.p.keyIsDown(provider.p.CONTROL)) {
            provider.view.move(0, event.delta / 8);
        } else if (provider.p.keyIsDown(provider.p.SHIFT)) {
            provider.view.move(event.delta / 8, 0);
        } else {
            if (event.delta < 0) {
                provider.view.zoomIn(provider.p.mouseX, provider.p.mouseY, 1.1);
            } else {
                provider.view.zoomOut(provider.p.mouseX, provider.p.mouseY, 1.1);
            }
        }
        return false; // disable normal scroll behavior
    }
}

export { mouseDragged, mouseMoved, mouseWheel, clickMouseOnCanvas, doubleClickedOnCanvas, pressMouseOnCanvas, releaseMouseOnCanvas, onCanvas };
